import { render, staticRenderFns } from "./ClockPickerCanvas.vue?vue&type=template&id=a0d3e860"
import script from "./ClockPickerCanvas.vue?vue&type=script&lang=js"
export * from "./ClockPickerCanvas.vue?vue&type=script&lang=js"
import style0 from "./ClockPickerCanvas.vue?vue&type=style&index=0&id=a0d3e860&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports